@if (datasetACS.datasetConfig) {
  <h1 mat-dialog-title>Prenotazione</h1>
}
<mat-dialog-content>
  @if (loading || datasetRS.loading.value || datasetACS.loading.value) {
    <mat-progress-bar class='mt-24 mb-24' style='min-width:300px' mode="indeterminate"></mat-progress-bar>
  }
  @if (datasetRS.record.value) {
    <div class='mb-24'>
      <p>{{'Codice' | translate}}: {{record.booking_code}}</p>
      <p>{{'Data Prenotazione' | translate}}: {{record.booking_date | date}}</p>
      <p class='pax-numb'>#Pax: {{record.participant_count}}</p>
      @for (tripBookingPackage of record.packages; track idTrackBy($index, tripBookingPackage)) {
        <div class="mat-elevation-z0 fx-column">
          <mat-toolbar class='trip-booking-package-header primary'>
            <mat-toolbar-row>
              @if (tripBookingPackage.actual_trip.type === "going") {
                <span>
                  {{'Andata' | translate}}:
                </span>
              }
              @if (tripBookingPackage.actual_trip.type === "return") {
                <span>
                  {{'Ritorno' | translate}}:
                </span>
              }
              <span class='ml-4'>
                <span>{{tripBookingPackage.trip_package.description}}</span>
              </span>
              <span class="fx-flex"></span>
              <strong>{{tripBookingPackage.total_amount | currency:'EUR' }}</strong>
            </mat-toolbar-row>
          </mat-toolbar>
          <div class='date-info-trip'>
            <p>
              <mat-icon>departure_board</mat-icon>
              <span class='ml-4'>Partenza: {{tripBookingPackage.actual_trip.start_day | date}} @if (tripBookingPackage.actual_trip.start_time) {
                {{tripBookingPackage.actual_trip.start_time.slice(0, 5)}}
              }</span>
            </p>
          </div>
          @if (tripBookingPackage.trip_booking_resources && tripBookingPackage.trip_booking_resources.length > 0) {
            <mat-toolbar class='risorse-header'>
              <mat-icon>directions_bus</mat-icon> {{'Risorse' | translate}}
            </mat-toolbar>
            <div class='trip-booking-resources-list'>
              @for (tripBookingResource of tripBookingPackage.trip_booking_resources; track idTrackBy($index, tripBookingResource)) {
                @if (tripBookingResource && (tripBookingResource.activated || !tripBookingResource.optional)) {
                  <mat-toolbar class='trip-booking-resource-header'>
                    <mat-toolbar-row>
                      <span class='ml-4'>
                        <span>{{tripBookingResource.trip_resource.description}}</span>
                        @if (!tripBookingResource.optional) {
                          <span class='secondary-text mat-caption ml-4 included'>Inclusa</span>
                        }
                        @if (tripBookingResource.optional) {
                          <span class='secondary-text mat-caption ml-4 optional'>Opzionale</span>
                        }
                      </span>
                      <span class="fx-flex"></span>
                      @if (tripBookingResource.optional) {
                        <strong>{{tripBookingResource.total_amount | currency:'EUR' }}</strong>
                      }
                    </mat-toolbar-row>
                  </mat-toolbar>
                }
              }
            </div>
          }
        </div>
      }
    </div>
  }
</mat-dialog-content>
<mat-dialog-actions align='end' class='booking-dialog-footer'>
  <button mat-button color='' (click)="onCloseClick()">{{'Chiudi' | translate}}</button>
</mat-dialog-actions>
